import { render, staticRenderFns } from "./QuestionVariableFields.vue?vue&type=template&id=597f94e0"
import script from "./QuestionVariableFields.vue?vue&type=script&lang=js"
export * from "./QuestionVariableFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports